var map = {
	"./gt/0.json": [
		5469,
		469
	],
	"./gt/1.json": [
		2434,
		434
	],
	"./gt/2.json": [
		1123,
		123
	],
	"./pa/0.json": [
		625,
		625
	],
	"./pa/1.json": [
		6630,
		630
	],
	"./pa/2.json": [
		6647,
		647
	],
	"./pa/3.json": [
		4276,
		276
	],
	"./sv/0.json": [
		9691,
		691
	],
	"./sv/1.json": [
		2504,
		504
	],
	"./sv/2.json": [
		9893,
		893
	],
	"./sv/3.json": [
		9450,
		450
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2368;
module.exports = webpackAsyncContext;